module.exports = __webpack_public_path__ + "img/pickFour.83e08c65.webp";